import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import CommentListing from "components/CommentListing/CommentListing";

import { Link, useNavigate, useParams } from "react-router-dom";
//import Input from "shared/Input/Input";
import { requestAPI } from "utils/api";



import Input from "shared/Input/Input";

import ButtonCircle from "shared/Button/ButtonCircle";
import { ArrowRightIcon, ArrowSmallLeftIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { GlobalDataContext } from "contexts/GlobalData";
import { UIContext } from "contexts/UIContext";

import ButtonPrimary from "shared/Button/ButtonPrimary";

import { productType } from "types/productType";
import { productCategory } from "types/productCategory";
import ExperiencesCard from "./ExperiencesCard";

//import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
  posts?: PostDataType[];
  className?: string;
  postCardName?: "card3";
}


const ProductMonthlyView = ({
  
}: any) => {

	const { id } = useParams();

	const {
		toast,
		modal,
	} = useContext (UIContext);  
	const { 
		initData
	} = useContext (GlobalDataContext);

	const navigate = useNavigate ();

	const tabs: any = productType;
	const [tabActive, setTabActive] = useState<any>(productType[0]);


	const tabs2: any = productCategory;
	const [tabActive2, setTabActive2] = useState<any>(productCategory[0]);


	const [datas, setDatas] = useState<any>({
		oList: [],
		list: []
	});
	

	useEffect(() => {
		(async () => {
			const res: any = await requestAPI('GET', `v1/product`, null);

			//setList(res.data.list);
			const _datas = {
				oList: res.data.list,
				list: res.data.list,
			};

			setDatas(_datas);

			//updateData(res.data.list);
		})();
	}, [])

	const updateData = (_data: any) => {

		const _datas: any = { ..._data };

		let newDatas = [];

		newDatas = fillterTab(_datas.oList, "type", tabActive.key);
		//newDatas = fillterTab(newDatas, "category", tabActive2.key);

		_datas.list = newDatas;

		setDatas(_datas);
	};

	const fillterTab = (_datas: any, key: string, value: string) => {

		let v: any = [];

		if (value === "all") {
			v = [..._datas];
		} else {
			_datas.forEach((item: any) => {

				if (item[key] === value) {
					v.push(item);
				}
			});
		}

		return v;
	}
	
	useEffect(() => {
		updateData(datas);
	}, [tabActive, tabActive2]);

	useEffect (() => {
		
		(async () => {
			
			
			

		})();
	}, []);

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
		
		const formattedTime2 = `${(hours < 10?"0":"")}${hours}:${minutes}`;

		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}.${month}.${day}`;
		
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			time2: formattedTime2,
			year: year,
			month: month,
			day: day,
		};
	};

	const handleBack = () => {
		navigate('/home');
	}
	
	//const _createdAt = formatKoreanDate(info.createdAt);
	
	const handleModify = () => {
		navigate(`/community-post/${id}`);
	};

	const emptyList = () => {
		return (
			<main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
				<div className="text-center">
					<p className="text-base font-semibold text-indigo-600">안내</p>
					<h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">등록된 상품이 없어요!</h1>
					<p className="mt-6 text-base leading-7 text-gray-600">해당 카테고리에 상품이 곧 등록될 예정이에요</p>

				</div>
			</main>
		)
	}

	//if(Object.keys(info).length === 0) return (<></>);
	

	return (
	<>
		<div className={`container relative nc-SectionLatestPosts overflow-y w-screen md:w-[768px] h-full bg-white !p-0`}>
		
			<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
				<div className="container flex items-center justify-between sm:w-[768px] !p-0">
					<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
						<button
							className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
							onClick={()=> handleBack()}
						>
							<ArrowSmallLeftIcon className="w-6 h-6" />
						</button>
						{/* <LikeSaveBtns /> */}
						<span
							className="text-xl"
						>
							뒤로
						</span>
					</div>
					<div className="pr-5">
					
					</div>
				</div>
			</div>

			<div className="flex flex-col lg:flex-row">
				<div className="w-screen pl-[1rem] pr-[1rem] mb-[10rem] space-y-5">
					
					<div className="flex">
						<h2 
							className={`text-3xl md:text-4xl font-semibold mt-0 text-[1.4rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							이달의 출발 상품
						</h2>
					</div>

					<div className="pt-[5px]">
					{
						datas.list.length > 0
							?
							<div className="mt-[16px] grid grid-cols-2 gap-6 md:grid-cols-3 ml-0 mr-0">
								{datas.list.map((item: any) => (
									<ExperiencesCard
										key={item.no}
										data={item}
									/>
								))}
							</div>
							:
							emptyList()
					}
					</div>

					
				</div>
				
			</div>
			
		</div>
	</>
	);
};

export default ProductMonthlyView;
